import type { JSX, ReactNode } from "react";
import { Navigate } from "react-router";

import { type Role, useSession } from "@/lib/supabase";

interface RequireRoleProps {
  roles: readonly Role[];
  children: ReactNode;
  loginPath?: string;
}

export function RequireRole({
  roles,
  children,
  loginPath = "/login",
}: RequireRoleProps): JSX.Element {
  const state = useSession();

  if (state.status === "loading") {
    return (
      <output
        aria-live="polite"
        className="min-h-screen flex items-center justify-center text-body-2 text-muted-foreground"
      >
        Cargando sesión…
      </output>
    );
  }

  if (state.status === "anonymous") {
    return <Navigate to={loginPath} replace />;
  }

  if (!roles.includes(state.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center p-6">
        <div className="max-w-md space-y-2 rounded-lg border border-border bg-card p-6 text-center shadow-sm">
          <p className="text-heading-3">Access denied</p>
          <p className="text-body-2 text-muted-foreground">
            Your account does not have permission to view this page.
          </p>
        </div>
      </div>
    );
  }

  return <>{children}</>;
}
